import { Injectable } from '@angular/core';
import { IndexedDBService } from '../../indexed-db.service';
import { ObjectStoreService } from '../abstract-object-store';
import { settingsObjectStore } from '../object-stores';
import { RouteSettings, Settings } from './settings';
import { ExaminationResult } from '../../../../examinationResult.model';
import { Lead } from '../../../../lead.model';

export const currentExaminationSettingsKey = 'currentExamination';
export const currentLanguageSettingsKey = 'language';
const routeSettingsKey = 'routeSettings';

export interface LeadWithExaminationResult {
  lead: Lead;
  examinationResult: ExaminationResult;
}

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends ObjectStoreService<Settings> {
  constructor(indexedDBService: IndexedDBService) {
    super(settingsObjectStore, indexedDBService);
  }

  async getSetting(key: string): Promise<Settings | undefined> {
    return await super.get(key);
  }

  async addSetting(setting: Settings): Promise<void> {
    await super.add(setting);
  }

  async replaceSetting(setting: Settings): Promise<void> {
    await super.replace(setting);
  }

  async deleteSetting(key: string): Promise<void> {
    await super.delete(key);
  }

  async deleteLeadWithExaminationResult(): Promise<void> {
    await this.deleteSetting(currentExaminationSettingsKey);
  }

  async getLeadWithExaminationResult(): Promise<LeadWithExaminationResult> {
    const leadWithExaminationResult = await this.getSetting(
      currentExaminationSettingsKey,
    );
    return JSON.parse(
      leadWithExaminationResult!.value,
    ) as LeadWithExaminationResult;
  }

  async setLeadWithExaminationResult(
    leadWithExaminationResult: LeadWithExaminationResult,
  ): Promise<void> {
    await this.replaceSetting({
      key: currentExaminationSettingsKey,
      value: JSON.stringify(leadWithExaminationResult),
    });
  }

  async getRouteSettings(): Promise<RouteSettings | undefined> {
    const settings = await this.getSetting(routeSettingsKey);
    if (!settings) return undefined;
    return JSON.parse(settings.value) as RouteSettings;
  }

  async setRouteSettings(routeSettings: RouteSettings) {
    await this.replaceSetting({
      key: routeSettingsKey,
      value: JSON.stringify(routeSettings),
    });
  }
}
